import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'isOldTimePipe',
})
export class IsOldTimePipe implements PipeTransform {
  transform(time: string, format: string): any {
    return moment(time, format).unix() < moment().unix();
  }
}
